/**
 * @desc 查询所有指数
 */
import {
  PriceIndexEntity,
  PriceIndexMallQuery
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryPriceIndexListParameter = PriceIndexMallQuery

const method = 'GET'
const url = '/content/mall/priceIndex/list'

export const queryPriceIndexListApi = (
  params?: QueryPriceIndexListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<PriceIndexEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryPriceIndexListApi.method = method
queryPriceIndexListApi.url = url
